const fmt = (h, m) => `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;

const OPTIONS = Array.from({ length: 96 }, (_, i) => ({ h: Math.floor(i / 4), m: (i % 4) * 15 }));

export const formatTime12 = fmt;

export const TimeSelect = ({ hour, minute, onChange, className = "", testid }) => {
  const opts = OPTIONS.some(o => o.h === hour && o.m === minute)
    ? OPTIONS
    : [...OPTIONS, { h: hour, m: minute }].sort((a, b) => a.h * 60 + a.m - (b.h * 60 + b.m));
  return (
    <select
      value={hour * 60 + minute}
      onChange={(e) => { const v = parseInt(e.target.value); onChange(Math.floor(v / 60), v % 60); }}
      className={`bg-bt-surface-2 border border-bt-border-subtle text-bt-text-primary font-mono text-sm px-3 py-2 ${className}`}
      data-testid={testid}
    >
      {opts.map(o => (
        <option key={o.h * 60 + o.m} value={o.h * 60 + o.m}>{fmt(o.h, o.m)}</option>
      ))}
    </select>
  );
};
